import { render, staticRenderFns } from "./CoursewareCanvasBlock.vue?vue&type=template&id=6a58894e&"
import script from "./CoursewareCanvasBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareCanvasBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a58894e')) {
      api.createRecord('6a58894e', component.options)
    } else {
      api.reload('6a58894e', component.options)
    }
    module.hot.accept("./CoursewareCanvasBlock.vue?vue&type=template&id=6a58894e&", function () {
      api.rerender('6a58894e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareCanvasBlock.vue"
export default component.exports